import React, { FC } from 'react';
import dynamic from 'next/dynamic';
import useTranslation from 'next-translate/useTranslation';

import { InfoCard } from 'common/components';
import WalletTabs from 'modules/userModule/components/WalletTabs';
import { useLayout, useUserInfo, useWalletTransactions } from 'service/hooks';
import useWalletBalanceWithCurrency from 'modules/userModule/hooks/useWalletBalanceWithCurrency';
import { LANGUAGE_AR } from 'common/constants';
import { StyledPageWrapper } from '../../../../common/styles';

const StoreFrontHeaderComponent = dynamic(() => import('common/components/StoreFrontHeader'));

const WalletPage: FC = () => {
  const { data: walletTransactions } = useWalletTransactions();
  const { data: userInfo } = useUserInfo();
  const { data: layoutSettings } = useLayout();
  const { t, lang } = useTranslation('wallet');
  const walletBalanceWithCurrency = useWalletBalanceWithCurrency();
  const walletBalance = userInfo?.walletBalance;
  const isArabic = lang === LANGUAGE_AR;

  return (
    <StyledPageWrapper>
      <StoreFrontHeaderComponent
        title={`${isArabic ? layoutSettings?.titleAr : layoutSettings?.titleEn} ${t('wallet').toLocaleLowerCase()}`}
      />
      <InfoCard text={walletBalanceWithCurrency} subText={t('walletDescription')} />
      <WalletTabs walletTransactions={walletTransactions} walletBalance={walletBalance} />
    </StyledPageWrapper>
  );
};
export default WalletPage;
